import React, { useState } from 'react';
import AddTableCard from './AddTableCard';
import TableCard from './TableCard';
import arrow1 from '../../public/icons/Arrow1.svg';
import arrow2 from '../../public/icons/Arrow2.svg';

const emptyTable = (id, name) => ({ id, name, role: '', canResolve: '', canReassign: '', finalLevel: '', escalationTime: '' });

function TableConnector({ accent }) {
  return (
    <div className={`ca-escalation-connector ca-escalation-connector--${accent}`} aria-hidden="true">
      <img src={arrow1} alt="" className="ca-escalation-connector__arrow ca-escalation-connector__arrow--first" />
      <span>Escalates to</span>
      <img src={arrow2} alt="" className="ca-escalation-connector__arrow ca-escalation-connector__arrow--second" />
    </div>
  );
}

export default function TableCardGrid({ initialTables, onChange }) {
  const [tables, setTables] = useState(() => initialTables?.length ? initialTables : [emptyTable(1, 'Level 1 - First Response'), emptyTable(2, 'Level 2 - Secondary')]);
  const updateTables = (nextTables) => { setTables(nextTables); onChange?.(nextTables); };
  const updateTable = (id, changes) => updateTables(tables.map((table) => table.id === id ? { ...table, ...changes } : table));
  const addTable = (name) => {
    const nextId = tables.reduce((highest, table) => Math.max(highest, Number(table.id) || 0), 0) + 1;
    updateTables([...tables, emptyTable(nextId, name)]);
  };

  return (
    <div className="ca-table-card-grid" aria-label="Escalation levels">
      <div className="ca-table-card-grid__track">
        {tables.map((table, index) => (
          <React.Fragment key={table.id}>
            <TableCard name={table.name} level={index + 1} value={table} onChange={(changes) => updateTable(table.id, changes)} />
            {index < tables.length  ? (
              <TableConnector accent={index === 0 ? 'green' : index === 1 ? 'orange' : 'purple'} />
            ) : null}
          </React.Fragment>
        ))}
        <AddTableCard level={tables.length + 1} onAdd={addTable} />
      </div>
    </div>
  );
}